module.exports = __webpack_public_path__ + "img/dollar.fb81a050.svg";